<template>
	<div :class="['flag__wrap', { 'flag__wrap--list': (view_type === 'list'), 'flag__wrap--card': (view_type === 'card'), 'flag__wrap--filter': (view_type === 'filter') } ]">
		<div class="list__body">
			<template v-if="view_type === 'filter'">
				<div class="list-item">
					<div class="d-radio">
						<input :id="`radio-${view_type}-${dbColName}-${randomKey}-all`" class="d-radio__mark" type="radio" :value="''" v-model="c_value" @change="onChange" :disabled="c_preventEdit">
						<label :for="`radio-${view_type}-${dbColName}-${randomKey}-all`" class="d-radio__label">Все</label> <!-- Не искать по этому полю -->
					</div>
				</div>
			</template>

			<div class="list-item">
				<div class="d-radio">
					<input :id="`radio-${view_type}-${dbColName}-${randomKey}-true`" class="d-radio__mark" type="radio" :value="true" v-model="c_value" @change="onChange" :disabled="c_preventEdit" ref="inputRef">
					<label :for="`radio-${view_type}-${dbColName}-${randomKey}-true`" class="d-radio__label">Да</label> <!-- inputRef для первичного фокуса в карточке -->
				</div>
			</div>

			<div class="list-item">
				<div class="d-radio">
					<input :id="`radio-${view_type}-${dbColName}-${randomKey}-false`" class="d-radio__mark" type="radio" :value="false" v-model="c_value" @change="onChange" :disabled="c_preventEdit">
					<label :for="`radio-${view_type}-${dbColName}-${randomKey}-false`" class="d-radio__label">Нет</label>
				</div>
			</div>

			<template v-if="!field_meta.required">
				<div class="list-item">
					<div class="d-radio">
						<input :id="`radio-${view_type}-${dbColName}-${randomKey}-null`" class="d-radio__mark" type="radio" :value="null" v-model="c_value" @change="onChange" :disabled="c_preventEdit">
						<label :for="`radio-${view_type}-${dbColName}-${randomKey}-null`" class="d-radio__label">Не&nbsp;задано</label>
					</div>
				</div>
			</template>

			<div class="help-block"></div>
			<div class="clearfix"></div>
		</div>
		<div class="ctrl-extraDescr" v-if="c_ctrlParams.extraDescr" v-html="c_ctrlParams.extraDescr"></div>
	</div>
</template>

<script>
	import ctrlMixins from './_mixins.js'
	import { ctrlParamsForAll } from './_common-stuff.ts';

	export default {
		name: 'ctrl_flag',
		meta: { // это наши данные, т.е. вуй при объявлении компонента их не использует
			title: 'Флаг',
			params: {
				defaultValue: {
					name: 'Значение по умолчанию',
					editType: 'flagRadio',
					tip: 'Применяется только в карточке и только при создании записи',
				},
				isReadonly: {
					name: 'Нередактируемый (для чтения)',
					editType: 'checkbox',
				},
				...ctrlParamsForAll,
			},
		},
		mixins: [ctrlMixins], // c_value, c_ctrlParams, c_srv_options, пропсы view_type, field_meta и так далее
		props: { // большая часть пропсов приезжает из ctrlMixins!
			value: {  // перезаписывается в beforeMount
			},
			item_key: {

			}
		},
		data () {
			return { }
		},
		computed: {
			c_preventEdit () {
				return this.$props.is_disabled || (this.$props.field_meta.ctrlParams.isReadonly && this.$props.view_type !== 'filter');
			},
			dbColName () {
				return this.field_meta.dbcolname
			},
			randomKey () {
				return this.item_key || this.field_meta.RANDOM_KEY
			}
		},
		beforeMount () {
			var isNullable = !this.$props.field_meta.required;
			var viewType = this.$props.view_type;

			// Для некоторых случаев устанавливаем значение

			// 1. Для фильтра. В нём по умолчанию Флаг имеет значение "не искать"
			if (viewType === 'filter') {
				if ([true, false, null].indexOf(this.value) !== -1) { // случай когда значение прилетает из util-filtermem.js (PIRS2018-86)
					this.c_value = this.value;
				}
				else {
					this.c_value = ''; // случай когда мы просто первый раз заходим в АРМ
				}
			}
			// 2. Для карточки при создании новой записи
			else if (this.$props.is_new_record) {
				var dv;
				var dvParam = this.$props.field_meta.ctrlParams.defaultValue;
				if (dvParam === true) {
					dv = true;
				}
				else if (dvParam === null && isNullable) {
					dv = null;
				}
				else if (dvParam === false) {
					dv = false;
				}
				else if (isNullable) {
					dv = null
				}
				this.c_value = dv;
			}
			// 3. Для пустой колонки в карточке и списке
			else if (typeof this.$props.value === 'undefined') {
				// при получении данных с пустой колонкой сервер не отдает поле без значения: {"fieldId":"audit_flag"}
				// боюсь много чего разломать, поэтому правим на клиенте локально, а не на сервере
				if (isNullable) {
					this.c_value = null;
				}
				else {
					console.error('Внимание! С сервера получено пустое значение, но в свойствах поля "' + this.$props.field_meta.dbcolname + '" указано "Обязательное", то есть null по идее недопустим. Возможны баги.')
				}
			}
		},
		methods: {
			onChange () {
				this.mixin_inputEvent(); // да, inputEvent не на @input, потому что тогда состояние в formdata попадает предыдущее, неактуальное
				this.mixin_saveEvent();
			},
		}
	}
</script>
